import styled from 'styled-components';

const ArrowImg = styled.img`
  width: ${({ isDesktop, open }) => {
    if (isDesktop) {
      return open ? '18px' : '9px';
    }
    return open ? '0.8em' : '0.4em';
  }};
  height: ${({ isDesktop, open }) => {
    if (isDesktop) {
      return open ? '9px' : '18px';
    }
    return open ? '0.4em' : '0.8em';
  }};
  padding-right: ${({ isDesktop, open }) => (isDesktop ? '0' : open ? '3%' : '4%')};
  margin-top: auto;
  margin-bottom: auto;
`;

export default ArrowImg;
